import onError from "./tools/bug-monitor.js";
import ws from "./ws/UniversalSocket.ts";

import {openMainMenu, closeMainMenu, uncheck, showAdvanced, initAdvancedOptions, setAdvancedOptions, advancedOptions, getOptimalWidth, warnWhichSelector,
	initRunnningTimers, saveMailWindow, findByIco, findByName, visibility} from "./intouch.js";

import {Suggester} from "./suggest/Suggest.js";
import {initPreview, initPreviewFor} from "./utils/WebPreview.ts";
import {validateBirthNumber} from "./utils/Util.js";

import {initSearch, SEARCH_CONTEXTS, searchOptions, searchFormCheckboxTick, setSearchInputPlaceholder} from "./search/search.js";

import "./utils/Extensions.js";
import "./utils/StrUtil.ts";
import "./utils/DateUtil.js";
import "./utils/MediaUtil.js";
import "./utils/GuiUtil.js";
import { setStackerIndex} from "@/utils/Stacker.ts";

import {msg} from "./i18n/Message.ts";		// Resource bundle msg()

import {showAdminMessage} from "./utils/AdminMessage.js";
import {openAlertWindow, openNotifications, openNotifyWindow} from "./utils/Notifications.js";
import {ChatClient} from "./chat/ChatClient.ts";
import {CtiWsRecipient} from "./cti/CtiWsRecipient.ts";

import lifecycle from "page-lifecycle";
import {startCheck, showPanelsAfterReady} from "./cti/cti.js";
import {showActionDialog} from "./cti/cti_callDialog.ts";
import {cleanAutoSaveItem, cleanLocalStorage, registerAutoSave} from "./utils/AutoSave.js";

import ClientCache from "./utils/ClientCache.js";
import ListManager from "./list/ListManager.js";
import SubtasksView from "./task/SubtasksView.vue";

import {tabBarExpand, initTabs, initFormNavigation} from "./utils/TabNavigation.js";

import {hookAgendaSlider} from "./utils/Agenda.js";
import {hookChartSelector} from "./chart/AgendaChart.js";

import "./overview/bonz.js";
import "./overview/tasklist.js";

import {DateTimeInput} from "./editors/DateTimeInput.js";
import {DateTimeEditor} from "./editors/DateTimeEditor.js";
import {CategoriesEditor} from "./categories/CategoriesEditor.js";
import {CategoriesInput, switchEnable} from "./categories/CategoriesInput.js";
import {changeMailAttribute, updateMailReferenceIcons} from "./mail/ViewMail.js";
import {loadVersions, stateChanged} from "./problem/edit.js";
import {SurchargeField, SumFields} from "./product/PriceCalculator.js";
import {CalcState, MoneyField, MoneyTaxField} from "./product/MoneyField.js";
import {ckEditorResize,setRefresh} from "./mail/SendMail.js";
import {MailFormClient} from "./mail/MailFormClient.js";

import {Temp} from "./utils/Temp.js";
import {skin} from "./utils/Skin.js";
import {DuplicatePartyChecker} from "./party/DuplicatePartyChecker.js";
import {LongOperation} from "./utils/LongOperation.js";
import {priceWithVat} from "./utils/Util.js";
import conductor, {MoneyEditingConductor} from "./product/MoneyEditingConductor.js";
import {priceChanger} from "./product/PriceChanger.js";
import {initContactEditing, showContactRichText} from "./contact/edit.js";
import {initCodeArea} from "./utils/CodeArea.js";
import {FactRouter} from "./party/FactRouter.js";
import {Money} from "./product/Money.js";
import {RepEventMenu} from "./event/RepEventMenu.js";
import {createCookie, getCookieVal, initValueFromCookie} from "./utils/Cookie.js";
import {ArrayEditor} from "./editors/ArrayEditor.js";
import {FormPartEditor} from "./editors/FormPartEditor.js";
import {printMessage, showHideFormatSelection} from "./utils/ajax.js";
import {loadNotUsedNumbers} from "./invoice/Invoice.js";
import {HtmlEditor} from "./editors/html/HtmlEditor.js";
import {ProcessEditor} from "./canvas/ProcessEditor.js";
import {SwitchMenu} from "./report/SwitchMenu.js";
import {EAddressEditor} from "./editors/EAddressEditor.js";
import {countGenericChars} from "./sms/edit.js";
import {SuggestEditor} from "./editors/SuggestEditor.js";

import {initSubviewTabs} from "./utils/Subview.js";
import {SubviewsLayoutEditor} from "./subviews/SubviewsLayoutEditor.js";
// Web Components
import "./wc/FIcon.js";	//<f-icon>
import {insertNewNoteEditor} from "./wc/CrmComment.js";	//<crm-note>
import "./editors/html/HtmlArea.js";	//<html-area>
//Vue components
import CrmTable from "./vue/table/CrmTable.vue";
import FileZone from "./vue/file/FileZone.vue";
import AutocompleteInput from "./vue/form/AutocompleteInput.vue";
import FileEntry from "./vue/file/FileEntry.vue";
import Avatar from "./vue/file/Avatar.vue";
import Attachments from "./vue/attachment/Attachments.vue";
import BulkMailForm from "./vue/form/BulkMailForm.vue";
import FileBrowser from "./vue/file/FileBrowser.vue";
import FileBrowserModal from "./vue/file/FileBrowserModal.vue";
import SortableArea from "./vue/list/SortableArea.vue";
import CrmInstall from "./vue/install/CrmInstall.vue";
import MentionField from "./vue/form/MentionField.vue";
import CommentsSubview from "./pages/subview/CommentsSubview.vue";
import OpenFileDialog from "./vue/file/OpenFileDialog.vue";
import OpenFileBrowser from "./vue/file/OpenFileBrowser.vue";
//Vue plugin components
import Vendors from "./vue/plugin/esprit/Vendors.vue";

import { installDirectives, installForm as vueFormInstall, installSecondaryForm as vueInstallSecondaryForm, installCreateDialog as vueInstallCreateDialog, JsonDump, DuplicateParties, provideEnv, provideEventBus } from "@fd/main";
import { useDesktop } from "./fd/DesktopEnvironment.ts";

import AppHeader from "@/ui/mouse/AppHeader.vue";
import TopNavigation from "@/ui/mouse/TopNavigation.vue";

import AppShell from "@/ui/AppShell.vue";
import {createApp, computed, type App, ComponentPublicInstance} from "vue";
import {envKey, userInRole} from "@fd/Environment";
import {initRouter} from "@/router/Router";
import resolvePageComponent from "@/router/PageResolver";

// Include CSS styles into the build
import "../css/style/index.css";
// Include all themes/skins
import "../css/themes/index.css";
import SideBarEmbed from "@/ui/mouse/SideBarEmbed.vue";
import EventColorInput from "@fd/editors/color/EventColorInput.vue";
import SelectTree from "@/ui/select/SelectTree.vue";
import {pinia} from "@/store/Store.ts";
import ForceInfos from "@/processes/ForceInfos.vue";
import ObjectLayout from "@/ui/subview/ObjectLayout.vue";
import {FormEnvironment} from "@fd/Types.ts";
import {UserInfo} from "@t/user/UserInfo.ts";
// import type {FormDefinition} from "@t/fd/layout/FormDefinition.ts";
// import type {FilterPart} from "@t/fd/editor/Filter.ts";
import CanvasCalendar from "@/event/calendar/CanvasCalendar.vue";
import {calendarSourceKey, CalendarSource} from "@/store/TodayStore.ts";
import {AppContextMap, ContextKey, contextKey, getIntValue, getValue, hasValue} from "@t/fd/AppContext.ts";
import FormPart from "@fd/containers/FormPart.vue";
import UiRoot from "@fd/containers/UiRoot.vue";
import {InterfaceRoot} from "@t/fd/InterfaceRoot.ts";
import {FormDefinition} from "@t/fd/layout/FormDefinition.ts";
import type {AgendaDescriptor} from "@t/agenda/Agenda.ts";
import {Filter} from "@t/agenda/Filter.ts";
import {FilterPart} from "@t/fd/editor/Filter.ts";
import {ActionPanelInstance} from "@t/ui/ActionPanel.ts";
import {FormData} from "@t/fd/FormPart.ts";

const crm = {url: Server.context};
const { env, getJson, putJson, postJson, patchJson } = useDesktop(crm, window.user);


const vue = {
	SubtasksView,FileZone,FileEntry,Attachments,CrmTable,AutocompleteInput,
	BulkMailForm,FileBrowser,FileBrowserModal,SortableArea,CrmInstall,MentionField,
	Vendors,CommentsSubview,Avatar,OpenFileDialog,OpenFileBrowser
};

/* Editor Components */
const ec = {
	DateTimeInput, DateTimeEditor, CategoriesEditor, CategoriesInput,
	ArrayEditor, FormPartEditor,
	HtmlEditor, ProcessEditor, EAddressEditor,
	SuggestEditor, SubviewsLayoutEditor
};


function installShell(attributes:AppContextMap, lastPath:string|null, containerId = "app-shell") {
	const hasUser = user != null && (user.access === "STANDARD" || user.access === "OPERATOR");
	const app = createApp(AppShell, {
		search: hasUser,
		notification: hasUser,
		file: "main.jsp"
	});
	app.provide(envKey, env);
	app.use(pinia);
	installDirectives(app, env);
    provideEventBus(app);
	initRouter(env, null, lastPath, attributes, true)
		.then((router) => {
			app.use(router);
			app.mount('#'+containerId);
		});
}

/** For Development (AS) */
function installPureShell(component: string, attributes:AppContextMap, lastPath:string|null, containerId: string) {
	resolvePageComponent(component).then((result) => {
		const app = createApp({ components: { Comp: result.default } }, {});
		app.provide(envKey, env);
		app.use(pinia);
		installDirectives(app, env);
		provideEventBus(app);
		initRouter(env, null, lastPath, attributes)
			.then((router) => {
				//console.log("router:"+JSON.stringify(router));
				app.use(router);
				app.mount('#'+containerId);
			});
	});
}

function mountApp(component, containerId, props = {}, context?:AppContextMap) {
	const app = createApp(component, props);
	app.provide(envKey, env);
	app.use(pinia);
	if (context) app.provide(contextKey, computed(() => context));
	return app.mount('#'+containerId);
}

function installEventColorPicker(containerId, property, value, readonly, tabindex, required) {
	const app = createApp(EventColorInput, {
		modelValue: value,
		tabindex: tabindex,
		readonly: readonly,
		property: property,
		required: required
	});
	app.use(pinia);
	return app.mount('#'+containerId);
}

function installSelectTree(containerId, selectHierarchy, property, value, readonly, tabindex, props = {}) {
	const app = createApp(SelectTree, {
		...props,
		tree: selectHierarchy,
		modelValue: value,
		tabindex: tabindex,
		disabled: readonly,
		property: property
	});
	app.use(pinia);
	return app.mount('#'+containerId);
}

function installCalendar(containerId:string,
						 source:CalendarSource|null, /* To init TodayStore */
						 context: AppContextMap, /* To init ContextStore */
						 display:string, showAttendees: "no"|"mono"|"full", minTime:number, maxTime: number,
						 snapMinutes:number, snapMonday:boolean, showTime:boolean, autocomplete:boolean, eventAlarm:number, wholeDayEventAlarm:number,
						) {
	const app = createApp(CanvasCalendar, {
		name: "overview",
		display,
		showAttendees,
		minTime, maxTime,
		snapMinutes, snapMonday, showTime,
		autocomplete, eventAlarm, wholeDayEventAlarm,
		context,
		canSplit: true
	});
	app.provide(envKey, env);
	if (source) app.provide(calendarSourceKey, source);
	if (context) app.provide(contextKey, computed(() => context));
	app.use(pinia);
	return app.mount('#' + containerId);
}

function installForm(container, part, data, readonly=false, viewmode=false, context, display, actions) {
	return vueFormInstall(container, env, part, data, readonly, viewmode, context, display, actions);
}

function installSecondaryForm(container, part, previous, readonly=false, viewmode=false, display, actions) {
	return vueInstallSecondaryForm(container, env, part, previous, readonly, viewmode, display, actions);
}

function installCreateDialog(modal:boolean, srcType:number, context?:AppContextMap, srcSubType?:number):Promise<FormData|null> {
	return vueInstallCreateDialog(env, modal, srcType, context, srcSubType);
}

/**
 * Purpose of this function is to install Vue app header (and top nav and stacker later)
 * to classic JSP/struts page. It helps with transition to Vue SPA.
 */
function installPageTop(containerId, pageFileName) {
    const enableSearch = env.user && (env.user.access === "STANDARD" || env.user.access === "OPERATOR") && userInRole(env.user, "ui.fulltext");
    const app = createApp(AppHeader, {
        search: enableSearch,
        notification: enableSearch,
        theme: true,
		file: pageFileName
    });
    app.provide(envKey, env);
	app.use(pinia);
    return app.mount('#' + containerId);
}

/**
 * Purpose of this function is to install Vue app header (and top nav and stacker later)
 * to classic JSP/struts page. It helps with transition to Vue SPA.
 */
function installTopNavigation(containerId, topMenu, activeSection, noCollapsing) {
    const app = createApp(TopNavigation, {
		menuData: topMenu,
		noCollapsing: noCollapsing,
		activeSection: activeSection
    });
    app.provide(envKey, env);
	app.use(pinia);
	installDirectives(app, env);
	initRouter(env)
		.then((router) => {
			app.use(router);
			app.mount('#'+containerId);
		});
}

function installForceInfos(containerId,
						   source:CalendarSource|null, /* To init TodayStore */
						   context: AppContextMap, /* To init ContextStore */
						   responsibles:number[] = [], options = {}) {
	if (responsibles.length === 0) responsibles.push(env.user.id);
	const props:Record<string, any> = {
		responsibles: responsibles,
		...options
	};
	if (hasValue(context, ContextKey.SRC_TYPE)) props.srcType = getIntValue(context, ContextKey.SRC_TYPE);
	if (hasValue(context, ContextKey.SRC_ID)) props.srcId = getValue(context, ContextKey.SRC_ID);
	console.log("installForceInfos props " + JSON.stringify(props));

	const app = createApp(ForceInfos, props);
	app.provide(envKey, env);
	if (source) app.provide(calendarSourceKey, source);
	if (context) app.provide(contextKey, computed(() => context));
	app.use(pinia);
	installDirectives(app, env);
	return app.mount('#' + containerId);
}

function installFilterEditor(containerId:string, descriptor:AgendaDescriptor, filter:Filter, readonly=false) {
	let ui:InterfaceRoot<FormDefinition> = {
		type: "interface",
		version: 2,
		lists: {},
		categories: {},
		define: {},
		methods: {},
		content: {
			type: "form",
			body: <FilterPart>{
				type: "filter",
				property: "filter",
				descriptor: descriptor
			}
		}
	};
	let data = { filter };
	return installForm('#' + containerId, ui, data, readonly, false, null, { mode: "body" }, []);
}

/**
 * @param {string} containerId
 * @param {SideMenu} sm
 * @param {History} history
 * @param panels list of action panels
 */
function installSideMenu(containerId, sm, history, panels:ActionPanelInstance<any>[] = []):ComponentPublicInstance {
	const app = createApp(SideBarEmbed, {
		menu: sm,
		history: history,
		panels: panels
	});
	app.provide(envKey, env);
	app.use(pinia);
	return app.mount('#' + containerId);
}

/**
 * @param {string} containerId
 * @param {string} name
 * @param {SubviewTab[]} subviews
 * @param {string} grab
 * @param {Subview} setup
 */
function instalObjectLayout(containerId, name, subviews, grab, setup) {
	const app = createApp(ObjectLayout, {
		name,
		subviews,
		grab,
		settings: setup
	});
	app.provide(envKey, env);
	app.use(pinia);
	installDirectives(app, env);
	return app.mount('#' + containerId);
}

const fd = {
	install: installDirectives,
	installForm,
	installSecondaryForm,
	installCreateDialog,
	FormPart,
	JsonDump,
	DuplicateParties	/* Vue implementation of party duplicity checker */,
	env: env,
	provideEnv,
	provideEventBus
};

const problem = {
	loadVersions, stateChanged
};

const product = {
	SurchargeField, SumFields,
	CalcState, MoneyField, MoneyTaxField,
	conductor, priceChanger,
	Money, MoneyEditingConductor
};

const party = {
	DuplicatePartyChecker, FactRouter
};

const contact = {
	initContactEditing, showContactRichText
};

const event = {
	initContactEditing, showContactRichText, RepEventMenu
};

const invoice = {
	loadNotUsedNumbers
};

const sms = {
	countGenericChars
};

const fetch = env.net.fetch;
const urlParam = env.net.urlParam;

const dynComp = () => import('./dev/pages/SampleForm.vue');

/**
 * This object is accessible through global variable `crm`
 */
export {
	onError, 	/* function to call for manully reporting an error */
	ws,			/* universal web socket */
	lifecycle,
	showAdvanced, initAdvancedOptions, advancedOptions, setAdvancedOptions, saveMailWindow,
	initPreview, initPreviewFor,		/* WebPreview hooks */
	openMainMenu, closeMainMenu, uncheck,
	showHideFormatSelection,
	initSearch, SEARCH_CONTEXTS, searchOptions, searchFormCheckboxTick, setSearchInputPlaceholder,	/* search */
	showAdminMessage,
	msg,
	openAlertWindow, openNotifications, openNotifyWindow,
	cleanAutoSaveItem,cleanLocalStorage,registerAutoSave,
	startCheck, showPanelsAfterReady, showActionDialog,	/* cti */
	tabBarExpand, initTabs,	initFormNavigation,							/* navigation */
	ChatClient,
	CtiWsRecipient,
	ClientCache,
	ListManager,
	vue,
	hookAgendaSlider,
	getOptimalWidth,
	hookChartSelector,
	warnWhichSelector,
	initRunnningTimers,
	ec,
	switchEnable,
	changeMailAttribute, updateMailReferenceIcons,
	problem,
	product,
	party,
	contact,
	event,
	invoice,
	sms,
	ckEditorResize,setRefresh,
	MailFormClient,
	Temp, skin,
	findByIco, findByName,
	LongOperation,
	priceWithVat,
	Suggester,
	initCodeArea,
	visibility,
	initValueFromCookie, createCookie, getCookieVal,
	printMessage,
	SwitchMenu,
	initSubviewTabs,
	insertNewNoteEditor,
	fd,

	getJson, putJson, postJson, patchJson, fetch, urlParam,

	validateBirthNumber,

	AppShell,dynComp,
	useDesktop,
	installShell,
    installPageTop,
	installTopNavigation,
	installSideMenu,
	installForceInfos,
	installFilterEditor,
	mountApp,
    setStackerIndex,
	installEventColorPicker,
	installSelectTree,
	instalObjectLayout,
	installCalendar,
	installPureShell
};
